import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.707 7.707L9 18.414l-4.707-4.707 1.414-1.414L9 15.586l9.293-9.293 1.414 1.414z" }));
export default createSvgIcon(iconPath, "Check");
//# sourceMappingURL=CheckIcon.js.map